import React from 'react'
import injectSheet from 'react-jss'
import styles from './form-label.styles'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const FormLabel = ({
  classes,
  className,
  spaceBetween,
  gapLeft,
  gapRight,
  small,
  required,
  children,
  ...props
}) => (
  <label
    className={classNames(
      classes.label,
      {
        [classes.spaceBetween]: spaceBetween,
        [classes.gapLeft]: gapLeft,
        [classes.gapRight]: gapRight,
        [classes.small]: small
      },
      className
    )}
    {...props}>
    {children}
    {required && <span className={classes.asterisk}>*</span>}
  </label>
)

FormLabel.propTypes = {
  /** Justify content - space between */
  spaceBetween: PropTypes.bool,
  /** Puts margin to the left, removes all other margins */
  gapLeft: PropTypes.bool,
  /** Puts margin to the right, removes all other margins */
  gapRight: PropTypes.bool,
  /** Smaller version of compoennt */
  small: PropTypes.bool,
  /** Additional className if you want to restyle component */
  className: PropTypes.string
}

export default injectSheet(styles)(FormLabel)
